export default __webpack_public_path__ + "static/media/cat6.4389d437.png";